import uuid from 'uuid/v4';

import request from 'yeself-common/utils/RequestUtils';
import { isValidRegExp } from 'yeself-common/JsUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';
import log from 'yeself-client-common/utils/LogUtils';

import './containers/Root';
import * as serviceWorker from './serviceWorker';

request.setOptions({ apiUrl: EnvironmentConfiguration.API_URL });
request.setHeader({
    'X-Request-Id': () => uuid(),
    'Content-Type': `application/json; version=${EnvironmentConfiguration.MODEL_VERSION.guide}`,
    Accept: `application/json; version=${EnvironmentConfiguration.MODEL_VERSION.guide}`,
});

log.init({
    serviceName: 'yeself-client-console',
    serverUrl: `${EnvironmentConfiguration.API_URL}/${EnvironmentConfiguration.APM.slug}`,
    serviceVersion: process.env.VERSION,
    environment: EnvironmentConfiguration.ENVIRONMENT,
    active: EnvironmentConfiguration.APM.active,
    transactionSampleRate: EnvironmentConfiguration.APM.transaction_sample_rate || 1,
    disableInstrumentations: EnvironmentConfiguration.APM.disable_instrumentations || [],
    ignoreTransactions: isValidRegExp(EnvironmentConfiguration.APM.ignore_transactions)
        ? [new RegExp(EnvironmentConfiguration.APM.ignore_transactions)]
        : [],
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
